export default function BulkDeleteArchivedReportInstancesConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  reportsDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    const idList = {};
    idList.ids = vm.archivedReportInstanceIds;
    return reportsDataService.bulkDeleteArchivedReportInstances(idList).then(() => {
      alerts.success('All selected Report Instances were successfully deleted.');
      $rootScope.$broadcast(`reports.archivedReports.reportType.archivedReportInstancesDeleted`, 
        { reportTypeId: vm.reportTypeId, numberOfInstancesDeleted: idList.ids.length} ); // eslint-disable-line max-len
      _closeDialog($event);
      ssDialogService.hide(ssDialogService.dialogs.reports.bulkDeleteArchivedReportInstancesDialog);
    }).catch(() => {
      alerts.error('An error occurred while deleting the selected Report Instances.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.bulkDeleteArchivedReportInstancesConfirmDialog);
  }
}

BulkDeleteArchivedReportInstancesConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'reportsDataService',
  'loaderService',
  'ssDialogService'
];
